<script setup>

</script>

<template>
  <div style="position: -webkit-sticky; position: sticky; top: 25px;">
    <v-card class="mb-4">
      <v-card-title>
        Faith
      </v-card-title>
      <v-divider />
      <v-list nav>
        <v-list-item
          title="What is the Gospel"
          to="/faith/what-is-the-gospel"
        />
        <v-list-item
          title="Take Your Next Step"
          to="/faith/next-steps"
        />
      </v-list>
    </v-card>
    <v-card class="mb-4">
      <v-card-title>
        Ministries
      </v-card-title>
      <v-divider />
      <v-list nav>
        <v-list-item
          title="Children's Ministries"
          to="/ministries/children"
        />
        <v-list-item
          title="Youth Group"
          to="/ministries/youth"
        />
        <v-list-item
          title="Discipleship"
          to="/ministries/discipleship"
        />
      </v-list>
    </v-card>
    <v-card>
      <v-card-title>
        About Us
      </v-card-title>
      <v-divider />
      <v-list nav>
        <v-list-item
          title="Our Story"
          to="/about/our-story"
        />
        <v-list-item
          to="/about/what-we-believe"
          title="What We Believe"
        />
        <v-list-item
          title="Plan Your Visit"
          to="/about/plan-your-visit"
        />
      </v-list>
    </v-card>
  </div>
</template>
